import { getCmsUsefulInformationAction } from "../../../Actions/LogicActions/Search/GetUsefulInformationAction";
import { usefulInfoCardClickAction } from "../../../Actions/LogicActions/Search/UsefulInfoCardClickAction";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { evtTree } from "../../../Orchestrator/ConstantTree";
import { IGetCmsUsefulInformationActionParams } from "../../../Orchestrator/Types/Interface/ICmsUsefulInformaton";
import { isWidgetEnabled } from "../../../Lib/Utils/isWidgetEnabled";

export class UsefulInformationStep extends StepFlow {
  get stepName() { return "UsefulInformationStep"; }

  async onEventSetup(): Promise<void> {
    this.registerEventSubscription(
      _eventBus.on({
        eventName: evtTree.helpInfo.Get,
        handler: async () => {
          if (!isWidgetEnabled("helpAndUsefulInformation")) return;
          getCmsUsefulInformationAction.execute();
        }
      })
    )

    this.registerEventSubscription(
      _eventBus.on<IGetCmsUsefulInformationActionParams, void>({
        eventName: evtTree.helpInfo.Details.Click,
        handler: async (data) => {
          usefulInfoCardClickAction.setParams(data.data!);
          await usefulInfoCardClickAction.execute();
        },
      })
    );
  }

  async onExecute(): Promise<void> {
    console.log("UsefulInformationStep Init Step Execute...");

    _eventBus.emit({
      eventName: evtTree.helpInfo.Get,
    });
  }
}
export const usefulInformationStepDeclaration = new StepDefinition({
  stepName: "UsefulInformationStep",
  stepClass: UsefulInformationStep
});